import React from "react";
import { Box, Typography, Collapse, useScrollTrigger } from "@material-ui/core";

import { useStyles } from "../../hooks";
import styles from "./styles";

const EmergencyNumberBar = () => {
  const classes = useStyles(styles);

  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  return (
    <Collapse in={!scrollTrigger}>
      <Typography component="div" className={classes.root}>
        <Box component="span" letterSpacing={0.2}  className={classes.mostrarTextT}>
          EMERGENCIAS&nbsp;|&nbsp;ORIENTACIÓN MÉDICA TELEFÓNICA:&nbsp;
        </Box>
        <Box component="span" letterSpacing={0.2}  className={classes.mostrarTextM}>
          EMERGENCIAS:&nbsp;
        </Box>
        <Box component="span" fontWeight={600} letterSpacing={0.26}>
          0810-888-ECCO (3226)
        </Box>
      </Typography>
    </Collapse>
  );
};

export default EmergencyNumberBar;
